import React, { Component } from "react";
import { connect } from "react-redux";
import Signbutton from "../../forms/button";
class onlineEmpanelementStatus extends Component {
  constructor(props) {
    super(props);
    !!this.props.location.state
      ? (this.state = {
          ...this.props.location.state,
          display: true,
          btn: "Hide Details",
        })
      : (this.state = {
          Message: "Something Went Wrong Please Try Again Later",
          display: true,
          btn: "Hide Details",
        });
  }

  render() {
    const BasicDetails = this.props.Nps_Basic_Details;
    const BankDetails = this.props.Nps_Bank_Details;
    return (
      <div className="container-margin">
        <div style={{ textAlign: "end", marginBottom: "20px" }}>
          Customer Support Email :{" "}
          <a href="mailto:npsdistributorsupport@kfintech.com">
            npsdistributorsupport@kfintech.com
          </a>
        </div>
        <div className="nps-head">
          Distribute National Pension System to your customers
        </div>
        <h4
          style={{
            marginLeft: "120px",
            marginRight: "120px",
            marginTop: "40px",
            marginBottom: "80px",
            textAlign: "center",
          }}
        >
          {this.state.Message}
        </h4>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <Signbutton
            buttontitle={this.state.btn}
            onClick={() =>
              this.setState((prevstate) => {
                return {
                  ...prevstate,
                  display: !prevstate.display,
                  btn: !prevstate.display ? "Hide Details" : "View Details",
                };
              })
            }
            padding={"15px 20px"}
          ></Signbutton>
        </div>

        {this.state.display && (
          <div>
            {" "}
            <div className="nps-forms" style={{ margin: "0 auto" }}>
              <div className="nps-forms-header">
                <h6 style={{ marginTop: "7.5px" }}>Basic Details</h6>
              </div>
              <div style={{ display: "flex" }}>
                <div className="nps-summary">
                  <p style={{ margin: "20px" }}>
                    Name* :{" "}
                    <span style={{ fontWeight: "500" }}>
                      {" "}
                      {BasicDetails.Name}
                    </span>
                  </p>
                  <p style={{ margin: "20px" }}>
                    Registered Address:{" "}
                    <span style={{ fontWeight: "500" }}>
                      {" "}
                      {BasicDetails.Address2 || "-"}
                    </span>
                  </p>
                  <p style={{ margin: "20px" }}>
                    Mobile*:{" "}
                    <span style={{ fontWeight: "500" }}>
                      {BasicDetails.MobileNo}
                    </span>
                  </p>
                </div>
                <div className="nps-summary">
                  <p style={{ margin: "20px" }}>
                    PAN*:{" "}
                    <span style={{ fontWeight: "500" }}>
                      {BasicDetails.PAN}
                    </span>
                  </p>
                  <p style={{ margin: "20px" }}>
                    Correspondence Address*:{" "}
                    <span style={{ fontWeight: "500" }}>
                      {BasicDetails.Address}
                    </span>
                  </p>
                  <p style={{ margin: "20px" }}>
                    Email Id*:{" "}
                    <span style={{ fontWeight: "500" }}>
                      {" "}
                      {BasicDetails.Email_Id}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <br />
            <div className="nps-forms" style={{ margin: "0 auto" }}>
              <div className="nps-forms-header">
                <h6 style={{ marginTop: "7.5px" }}>Bank Details</h6>
              </div>
              <div style={{ display: "flex" }}>
                <div className="nps-summary">
                  <p style={{ margin: "20px" }}>
                    Bank Account Number* :{" "}
                    <span style={{ fontWeight: "500" }}>
                      {" "}
                      {BankDetails.AccountNumber}
                    </span>
                  </p>
                  <p style={{ margin: "20px" }}>
                    Bank Name*:{" "}
                    <span style={{ fontWeight: "500" }}>
                      {" "}
                      {BankDetails.BankName}
                    </span>
                  </p>
                </div>
                <div className="nps-summary">
                  <p style={{ margin: "20px" }}>
                    IFSC*:{" "}
                    <span style={{ fontWeight: "500" }}>
                      {" "}
                      {BankDetails.IFSC}
                    </span>
                  </p>
                  <p style={{ margin: "20px" }}>
                    Branch*:{" "}
                    <span style={{ fontWeight: "500" }}>
                      {" "}
                      {BankDetails.Branch}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(({ authReducer }) => {
  const { Nps_Basic_Details, Nps_Bank_Details } = authReducer;
  return { Nps_Basic_Details, Nps_Bank_Details };
})(onlineEmpanelementStatus);
